import router from "../router";
import { post } from "../utils/request";
import { getTaskTypeName } from "../utils/utilApi";
import { DEPT_LEADER } from "../utils/utilData";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      showableComp: {
        showPersonalEvaTable: false,
      },
      disableComp: {
        submit: false,
        subScoreBtn: false,
      },
      pageInfo: "",
      modelId: "",
      modelRoleId: "",
      personalEvaList: [],
      personalEvaForm: {
        behaviorId: "",
        userId: "",
        name: "",
        departmentName: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentName,
        position: "",
        // 最终得分
        score: 100,
        // 标准分值，即上序用户评分
        lastScore: "",
        year: "",
        season: "",
        departmentId: JSON.parse(sessionStorage.getItem("userInfo")).departmentId,
        title: "个性指标考核",
        taskList: [],
        // 任务扣分记录，只记录扣分部分
        taskSubList: [],
        // 总体再扣分
        totalSubScore: 0,
        // 个性指标总扣分
        subScore: 0,
        summary: "",
        remarks: "",
        taskNum: " ",
        appendixList: [{ name: 'food.jpeg', url: '111' }],
        subjectType: "个人",
      },
      appendixForm: {
        name: "",
        url: "",
      },
      // 没啥用
      taskForm: {
        taskId: "",
        categoryName: "",
        taskDetail: "",
        evaCriterion: "",
        taskType: "",
        accomplish: "",
        accomplishRatio: "",
        accomplishDetail: "",
        score: "",
        remarks: "",
      },
      taskEvaTable: [
        {
          label: "任务分类",
          prop: "categoryName",
        },
        {
          label: "工作内容",
          prop: "taskDetail",
        },
        {
          label: "标准要求",
          prop: "evaCriterion",
        },
        {
          label: "任务类型",
          prop: "taskType",
        },
        {
          label: "是否完成",
          prop: "accomplish",
        },
        {
          label: "完成比例",
          prop: "accomplishRatio",
        },
        {
          label: "完成情况",
          prop: "accomplishDetail",
        },
        {
          label: "标准分值",
          prop: "score",
        },
      ],
      personalEvaListTable: [
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "科室",
          prop: "departmentName",
        },
        {
          label: "职务/职级",
          prop: "position",
        },
        {
          label: "得分",
          prop: "score",
        },
      ],
    };
  },
  name: "PersonalEva",
  methods: {
    doCancel() {
      this.showableComp.showPersonalEvaTable = false;
    },
    handleEva(index, personItem) {
      this.personalEvaForm.behaviorId = personItem.behaviorId;
      this.personalEvaForm.name = personItem.name;
      this.personalEvaForm.departmentName = personItem.departmentName;
      this.personalEvaForm.position = personItem.position;
      this.personalEvaForm.score = personItem.score;
      this.personalEvaForm.userId = personItem.userId;
      // if (personItem.score == "") {
      //   // 未评分
      //   this.searchDepTaskBatch();
      // } else {
      //   // 已评分
      //   this.searchTaskWithScore();
      // }
      this.searchTaskWithScore();

      this.showableComp.showPersonalEvaTable = true;
    },
    formatter(row, column) {
      if (column.property == "taskType") {
        return getTaskTypeName(row.taskType);
      } else if (column.property == "accomplish") {
        return row.accomplish == true ? "已完成" : "未完成";
      } else if (column.property == "score") {
        return row.totalScore;
      } else {
        return row[column.property];
      }
    },
    // 根据behaviorId查找季度任务
    searchDepTaskBatch() {
      let behaviorId = this.personalEvaForm.behaviorId;
      post('/task/search/id', JSON.stringify(behaviorId)).then((res) => {
        if (res.code == 200) {
          this.personalEvaForm.taskList = JSON.parse(res.data.taskList);
        }
      });
    },
    goBack() {
      router.push("/eva-events");
    },
    downloadFile(url) {
      console.log("下载附件");
    },
    /**
     * @function POST /personalItem/detail/search
     * @description 查看考评主体的季度任务和详细评分情况
     * @param subjectId 考核主体ID
     * @param behaviorId 工作情况报告ID
     * @param modelId 考核模型ID
     * 
     * @returns R.success().code(200).data(taskList)
     * @returns taskList中包含属性：taskId任务ID，categoryName任务分类，taskDetail任务内容，evaCriterion标准要求，taskType任务类型，accomplish是否完成，accomplishRatio完成比例，accomplishDetail完成情况，score标准分值，subScore扣分属性（未扣分的任务此属性为0或空）
     */
    searchTaskWithScore() {
      let data = {
        subjectId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        behaviorId: this.personalEvaForm.behaviorId,
        modelId: this.modelId,
      }
      post('/personalItem/detail/search', JSON.stringify(data)).then((res) => {
        this.personalEvaForm.taskList = JSON.parse(res.data.taskList);
        let nextRole = res.data.roleId;

        // 获取逐级评分的历次情况
        let scoreList = JSON.parse(res.data.scoreList);
        if (scoreList == null || scoreList == "" || scoreList.length == 0) {
          this.personalEvaForm.lastScore = 100;
          this.personalEvaForm.score = this.personalEvaForm.lastScore;
        } else {
          // 遍历查看是否当前用户的扣分情况
          for (let i = 0; i < scoreList.length; i++) {
            // 表格中插入列
            let prop = "sub" + scoreList[i].evaOrder;
            this.taskEvaTable.push({
              label: "第" + scoreList[i].evaOrder + "轮扣分",
              prop: prop,
              fixed: "right",
            });
            // 增加新插入列的数据
            // 两个数组都按taskId排序，因此可稍做优化
            for (let taskId in scoreList[i].taskScore) {
              let start = 0;
              for (let j = start; j < this.personalEvaForm.taskList.length; j++) {
                if (this.personalEvaForm.taskList[j].taskId == taskId) {
                  this.personalEvaForm.taskList[j][prop] = scoreList[i].taskScore[taskId];
                  start = j + 1;
                  break;
                }
              }
            }

            // 若已评分则提交按钮不可用
            if (scoreList[i].subjectId == JSON.parse(sessionStorage.getItem("userInfo")).userId) {
              this.disableComp.submit = true;
              break;
            }
            this.disableComp.submit = false;
          }
          // 如果被评分者当前评分次序的role和当前评分者的role不符，则不允许评分
          if (JSON.parse(sessionStorage.getItem("roleList"))[0].roleId != parseInt(nextRole)) {
            this.disableComp.submit = true;
            ElMessage.warning("上一次序用户评价未完成，暂时不允许评价", {
              duration: 3 * 1000,
            });
            return;
          } else {
            this.disableComp.submit = false;
          }
          this.personalEvaForm.lastScore = scoreList[scoreList.length - 1].score;
          this.personalEvaForm.score = this.personalEvaForm.lastScore;
        }
      });
    },
    /**
     * @function POST /personalItem/save
     * @description 保存提交的个性指标评价
     * @param behaviorId 工作情况报告ID
     * @param modelId 考核对象模型ID
     * @param modelRoleId 考核主体模型ID
     * @param subjectId 考核主体ID
     * @param name 考评对象姓名
     * @param score 最终得分
     * @param totalSubScore 总体再扣分
     * @param taskSubList 扣分任务列表
     * 
     * @returns R.success().code(200).message("评价成功")
     */
    saveEva() {
      this.calTaskSubList();
      let data = this.personalEvaForm;
      delete data.taskList;
      delete data.appendixList;
      data.modelId = this.modelId;
      data.modelRoleId = this.modelRoleId;
      data.subjectId = JSON.parse(sessionStorage.getItem("userInfo")).userId;
      post('/personalItem/save', JSON.stringify(data)).then((res) => {
        this.showableComp.showPersonalEvaTable = false;
        for (let i = 0, len = this.personalEvaList.length; i < len; i++) {
          if (this.personalEvaList[i].behaviorId == data.behaviorId) {
            this.personalEvaList[i].score = data.score;
          }
        }
        this.personalEvaForm.score = res.score;
      });
    },
    // 把扣分任务push到数组中
    calTaskSubList() {
      this.personalEvaForm.taskSubList = [];
      for (let i = 0, len = this.personalEvaForm.taskList.length; i < len; i++) {
        if (this.personalEvaForm.taskList[i].subScore > 0) {
          this.personalEvaForm.taskSubList.push(this.personalEvaForm.taskList[i]);
        }
      }
    },
    // 统计全部任务的扣分值
    calSubScore() {
      this.personalEvaForm.subScore = 0;
      for (let i = 0, len = this.personalEvaForm.taskList.length; i < len; i++) {
        if (this.personalEvaForm.taskList[i].subScore > 0) {
          this.personalEvaForm.subScore += parseInt(this.personalEvaForm.taskList[i].subScore);
        }
      }
    },
    change(taskItem) {
      if (taskItem.subScore == "") {
        taskItem.subScore = 0;
      }
      this.calSubScore();
    },
    /**
     * @function POST /personalItem/object/search
     * @description 查找需要进行个性指标评价的用户
     * @param modelId 模型ID
     * @param object 考评对象
     * @param subject 考评主体
     * @param userId 当前用户ID
     * @param roleIdList 当前用户的角色集合
     * @param evaType 评价方式（自评、互评、领导评、其他）
     * 
     * 
     * @returns R.success().code(200).message("查询成功").data(personalEvaList[])
     * @returns personalEvaList[]中每一个对象包括behaviorId工作情况报告ID, name考评对象姓名, departmentName部门名称, position职务, score分数
     */
    personalObjSearch(param) {
      let arr = JSON.parse(sessionStorage.getItem("roleList"));
      for (let i = 0, len = arr.length; i < len; i++) {
        arr[i] = arr[i].roleId;
      }
      let data = param;
      data.userId = JSON.parse(sessionStorage.getItem("userInfo")).userId;
      data.roleIdList = arr;
      post('/personalItem/object/search', JSON.stringify(data)).then((res) => {
        this.personalEvaList = JSON.parse(res.data.personalEvaList);
      });
    },
  },
  computed: {},
  created() {
    this.modelId = this.$route.params.modelId;
    this.modelRoleId = this.$route.params.modelRoleId;
    this.personalEvaForm.behaviorId = this.$route.params.behaviorId;
    this.personalObjSearch(this.$route.params);
    this.pageInfo = this.$route.params;
    // 只有分管局长才有总体扣分的权限
    if (DEPT_LEADER == JSON.parse(sessionStorage.getItem("roleList"))[0].roleId) {
      this.disableComp.subScoreBtn = false;
    } else {
      this.disableComp.subScoreBtn = true;
    }
  },
  watch: {
    "personalEvaForm.subScore"() {
      this.personalEvaForm.score = this.personalEvaForm.lastScore - this.personalEvaForm.subScore - this.personalEvaForm.totalSubScore;
    },
    "personalEvaForm.totalSubScore"() {
      this.personalEvaForm.score = this.personalEvaForm.lastScore - this.personalEvaForm.subScore - this.personalEvaForm.totalSubScore;
    }
  }
};